// 综合验证

import { message } from "ant-design-vue";
export const validatePhone =(phone)=> {
  // 1. 非空验证
  if (!phone) {
    message.warning("手机号码不能为空");
    return false;
  }
  
  // 2. 去除空格
  phone = phone.trim();
  
  // 3. 纯数字验证（不允许小数点和负号）
  if (!/^\d+$/.test(phone)) {
    message.warning("手机号码只能包含数字");
    return false;
  }
  
  // 4. 长度验证（以11位为例）
  if (phone.length !== 11) {
    message.warning("手机号码必须是11位");
    return false;
  }
  
  // 5. 手机号格式验证（中国大陆）
  if (!/^1[3-9]\d{9}$/.test(phone)) {
    message.warning("请输入正确的手机号码");
    return false;
  }
  
  return true;
}


// WEBPACK FOOTER //
// ./src/utils/validatePhone.js